import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
export type DateRelativeDefaultValueConfig_FragmentFragment = {
   __typename?: 'DateRelativeDefaultValueConfig'
   operator: Types.ArithmeticOperation
   noOfDays: number
   DateValueEnum: Types.DateValueEnum
}

export type TimeRelativeDefaultValueConfig_FragmentFragment = {
   __typename?: 'TimeRelativeDefaultValueConfig'
   operator: Types.ArithmeticOperation
   noOfSeconds: number
   TimeValueEnum: Types.TimeValueEnum
}

export type Sales_Crm_Web_Common_IntegerFieldFragment = {
   __typename?: 'IntegerField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isUnique: boolean
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   intDefaultValue?: number | null
   rangeConfig?: {
      __typename?: 'IntegerRangeConfig'
      intMinValue?: number | null
      intMaxValue?: number | null
   } | null
}

export type Sales_Crm_Web_Common_FloatFieldFragment = {
   __typename?: 'FloatField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isUnique: boolean
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   decimalPrecisionLimit?: number | null
   floatDefaultValue?: number | null
   rangeConfig?: {
      __typename?: 'FloatRangeConfig'
      floatMinValue?: number | null
      floatMaxValue?: number | null
   } | null
}

export type Sales_Crm_Web_Common_EmailFieldFragment = {
   __typename?: 'EmailField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   isUnique: boolean
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Common_FileUploaderFieldFragment = {
   __typename?: 'FileUploaderField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   allowedFormats: Array<string>
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   maxNumberOfFilesToUpload: number
   eachFileMaxSizeInKb: number
   canDownload: boolean
   allowPublicAccess: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Common_LongTextFieldFragment = {
   __typename?: 'LongTextField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   regexErrorMessage?: string | null
   validationRegex?: string | null
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Common_GeoLocationFieldFragment = {
   __typename?: 'GeoLocationField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   addressFieldIds: Array<string>
   iconId?: string | null
   tags: Array<Types.FieldTag>
}

export type Sales_Crm_Web_Common_GeoShapeFieldFragment = {
   __typename?: 'GeoShapeField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   variantType: Types.GeoShapeVariantType
   addressFieldIds: Array<string>
   iconId?: string | null
   tags: Array<Types.FieldTag>
}

export type Sales_Crm_Web_Common_PlainTextFieldFragment = {
   __typename?: 'PlainTextField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   isUnique: boolean
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isIdentificationField: boolean
   isFormulaEnabled: boolean
   autoGenerateApplicationIdInCreation: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Common_ShortTextFieldFragment = {
   __typename?: 'ShortTextField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isUnique: boolean
   isIdentificationField: boolean
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
   prefixOptions?: {
      __typename?: 'PrefixOptions'
      isEnabled: boolean
      values: Array<string>
      optionsValueType: Types.OptionsValueType
      conditionalPrefixOptions: Array<{
         __typename?: 'ConditionalFieldOptions'
         parentFieldId: string
         options: Array<{
            __typename?: 'ConditionalOptions'
            options: Array<string>
            parentFieldOption: string
         }>
      }>
   } | null
   suffixOptions?: {
      __typename?: 'SuffixOptions'
      isEnabled: boolean
      values: Array<string>
   } | null
}

export type Sales_Crm_Web_Common_UrlFieldFragment = {
   __typename?: 'URLField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   alternateDisplayText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   isUnique: boolean
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Common_TimeFieldFragment = {
   __typename?: 'TimeField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   isDependent: boolean
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   timeFieldDefaultValue?: string | null
   relativeDefaultValueConfig?: {
      __typename?: 'TimeRelativeDefaultValueConfig'
      operator: Types.ArithmeticOperation
      noOfSeconds: number
      TimeValueEnum: Types.TimeValueEnum
   } | null
}

export type Sales_Crm_Web_Common_DateFieldFragment = {
   __typename?: 'DateField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   isDependent: boolean
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   dateFieldDefaultValue?: string | null
   relativeDefaultValueConfig?: {
      __typename?: 'DateRelativeDefaultValueConfig'
      operator: Types.ArithmeticOperation
      noOfDays: number
      DateValueEnum: Types.DateValueEnum
   } | null
}

export type Sales_Crm_Web_Common_DateTimeFieldFragment = {
   __typename?: 'DateTimeField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   dateTimeDefaultValue?: string | null
   relativeDefaultValueConfig?: {
      __typename?: 'DateTimeRelativeDefaultValueConfig'
      dateConfig?: {
         __typename?: 'DateRelativeDefaultValueConfig'
         operator: Types.ArithmeticOperation
         noOfDays: number
         DateValueEnum: Types.DateValueEnum
      } | null
      timeConfig?: {
         __typename?: 'TimeRelativeDefaultValueConfig'
         operator: Types.ArithmeticOperation
         noOfSeconds: number
         TimeValueEnum: Types.TimeValueEnum
      } | null
   } | null
}

export type Sales_Crm_Web_Common_DropdownFieldFragment = {
   __typename?: 'DropdownField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isLabelsEnabled: boolean
   optionsValueType: Types.OptionsValueType
   iconId?: string | null
   tags: Array<Types.FieldTag>
   dropdownFieldUiStyle: Types.DropdownFieldUiStyleEnum
   allowOtherOptions: boolean
   stringDefaultValue?: string | null
   optionColors: Array<{
      __typename?: 'OptionColorConfig'
      option: string
      color: Types.ColorEnum
   }>
   conditionalOptions: Array<{
      __typename?: 'ConditionalFieldOptions'
      parentFieldId: string
   }>
}

export type Sales_Crm_Web_Common_MultiSelectFieldFragment = {
   __typename?: 'MultiSelectField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isLabelsEnabled: boolean
   optionsValueType: Types.OptionsValueType
   iconId?: string | null
   tags: Array<Types.FieldTag>
   multiSelectFieldUiStyle: Types.MultiSelectFieldUiStyleEnum
   allowOtherOptions: boolean
   multiStringDefaultValue: Array<string>
   optionColors: Array<{
      __typename?: 'OptionColorConfig'
      option: string
      color: Types.ColorEnum
   }>
   conditionalOptions: Array<{
      __typename?: 'ConditionalFieldOptions'
      parentFieldId: string
   }>
}

export type Sales_Crm_Web_Common_CheckboxGroupFieldFragment = {
   __typename?: 'CheckboxGroupField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   multiStringDefaultValue: Array<string>
}

export type Sales_Crm_Web_Common_RadioGroupFieldFragment = {
   __typename?: 'RadioGroupField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Common_PhoneNumberFieldFragment = {
   __typename?: 'PhoneNumberField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isUnique: boolean
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isIdentificationField: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   enableOtpVerification?: boolean | null
}

export type Sales_Crm_Web_Common_FieldsSelectorFieldFragment = {
   __typename?: 'FieldsSelectorField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isDependent: boolean
   options: Array<string>
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   fieldsSelectorFieldUiStyle: Types.FieldSelectorFieldUiStyleEnum
   fieldSelectorFieldDefaultValue?: string | null
   dependentFields: Array<{
      __typename?: 'DependentFields'
      option: string
      dependentFieldIds: Array<string>
   }>
}

export type Sales_Crm_Web_Common_RelationFieldFragment = {
   __typename?: 'RelationField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   referenceId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   linkedSourceFieldId?: string | null
   valueType: Types.RelationFieldValueType
   parentFieldOptions?: {
      __typename?: 'ParentFieldOptions'
      options: Array<string>
      parentFieldId: string
   } | null
   relation: {
      __typename?: 'RelationOverviewDetails'
      cardinality: Types.Cardinality
      name: string
      relationId: string
      fromSalesTemplateConfig: {
         __typename?: 'RelatedSalesTemplateOverviewDetails'
         salesTemplateId: string
         displayName: string
         pipelineItemType?: Types.PipelineItemType | null
         salesTemplateName: string
         salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
      }
      toSalesTemplateConfig: {
         __typename?: 'RelatedSalesTemplateOverviewDetails'
         salesTemplateId: string
         salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
         displayName: string
         pipelineItemType?: Types.PipelineItemType | null
         salesTemplateName: string
      }
   }
   secondDegreeRelation?: {
      __typename?: 'RelationOverviewDetails'
      cardinality: Types.Cardinality
      name: string
      relationId: string
      fromSalesTemplateConfig: {
         __typename?: 'RelatedSalesTemplateOverviewDetails'
         salesTemplateId: string
         displayName: string
         pipelineItemType?: Types.PipelineItemType | null
         salesTemplateName: string
         salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
      }
      toSalesTemplateConfig: {
         __typename?: 'RelatedSalesTemplateOverviewDetails'
         salesTemplateId: string
         salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
         displayName: string
         pipelineItemType?: Types.PipelineItemType | null
         salesTemplateName: string
      }
   } | null
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_CheckboxGroupField_Fragment = {
   __typename?: 'CheckboxGroupField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   multiStringDefaultValue: Array<string>
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_DateField_Fragment = {
   __typename?: 'DateField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   isDependent: boolean
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   dateFieldDefaultValue?: string | null
   relativeDefaultValueConfig?: {
      __typename?: 'DateRelativeDefaultValueConfig'
      operator: Types.ArithmeticOperation
      noOfDays: number
      DateValueEnum: Types.DateValueEnum
   } | null
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_DateTimeField_Fragment = {
   __typename?: 'DateTimeField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   dateTimeDefaultValue?: string | null
   relativeDefaultValueConfig?: {
      __typename?: 'DateTimeRelativeDefaultValueConfig'
      dateConfig?: {
         __typename?: 'DateRelativeDefaultValueConfig'
         operator: Types.ArithmeticOperation
         noOfDays: number
         DateValueEnum: Types.DateValueEnum
      } | null
      timeConfig?: {
         __typename?: 'TimeRelativeDefaultValueConfig'
         operator: Types.ArithmeticOperation
         noOfSeconds: number
         TimeValueEnum: Types.TimeValueEnum
      } | null
   } | null
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_DropdownField_Fragment = {
   __typename?: 'DropdownField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isLabelsEnabled: boolean
   optionsValueType: Types.OptionsValueType
   iconId?: string | null
   tags: Array<Types.FieldTag>
   dropdownFieldUiStyle: Types.DropdownFieldUiStyleEnum
   allowOtherOptions: boolean
   stringDefaultValue?: string | null
   optionColors: Array<{
      __typename?: 'OptionColorConfig'
      option: string
      color: Types.ColorEnum
   }>
   conditionalOptions: Array<{
      __typename?: 'ConditionalFieldOptions'
      parentFieldId: string
   }>
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_EmailField_Fragment = {
   __typename?: 'EmailField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   isUnique: boolean
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_FieldsSelectorField_Fragment = {
   __typename?: 'FieldsSelectorField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isDependent: boolean
   options: Array<string>
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   fieldsSelectorFieldUiStyle: Types.FieldSelectorFieldUiStyleEnum
   fieldSelectorFieldDefaultValue?: string | null
   dependentFields: Array<{
      __typename?: 'DependentFields'
      option: string
      dependentFieldIds: Array<string>
   }>
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_FileUploaderField_Fragment = {
   __typename?: 'FileUploaderField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   allowedFormats: Array<string>
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   maxNumberOfFilesToUpload: number
   eachFileMaxSizeInKb: number
   canDownload: boolean
   allowPublicAccess: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_FloatField_Fragment = {
   __typename?: 'FloatField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isUnique: boolean
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   decimalPrecisionLimit?: number | null
   floatDefaultValue?: number | null
   rangeConfig?: {
      __typename?: 'FloatRangeConfig'
      floatMinValue?: number | null
      floatMaxValue?: number | null
   } | null
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_GeoLocationField_Fragment = {
   __typename?: 'GeoLocationField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   addressFieldIds: Array<string>
   iconId?: string | null
   tags: Array<Types.FieldTag>
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_GeoShapeField_Fragment = {
   __typename?: 'GeoShapeField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   variantType: Types.GeoShapeVariantType
   addressFieldIds: Array<string>
   iconId?: string | null
   tags: Array<Types.FieldTag>
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_IntegerField_Fragment = {
   __typename?: 'IntegerField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isUnique: boolean
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   intDefaultValue?: number | null
   rangeConfig?: {
      __typename?: 'IntegerRangeConfig'
      intMinValue?: number | null
      intMaxValue?: number | null
   } | null
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_LongTextField_Fragment = {
   __typename?: 'LongTextField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   regexErrorMessage?: string | null
   validationRegex?: string | null
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_MultiSelectField_Fragment = {
   __typename?: 'MultiSelectField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isLabelsEnabled: boolean
   optionsValueType: Types.OptionsValueType
   iconId?: string | null
   tags: Array<Types.FieldTag>
   multiSelectFieldUiStyle: Types.MultiSelectFieldUiStyleEnum
   allowOtherOptions: boolean
   multiStringDefaultValue: Array<string>
   optionColors: Array<{
      __typename?: 'OptionColorConfig'
      option: string
      color: Types.ColorEnum
   }>
   conditionalOptions: Array<{
      __typename?: 'ConditionalFieldOptions'
      parentFieldId: string
   }>
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_PhoneNumberField_Fragment = {
   __typename?: 'PhoneNumberField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isUnique: boolean
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isIdentificationField: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   enableOtpVerification?: boolean | null
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_PlainTextField_Fragment = {
   __typename?: 'PlainTextField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   isUnique: boolean
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isIdentificationField: boolean
   isFormulaEnabled: boolean
   autoGenerateApplicationIdInCreation: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_RadioGroupField_Fragment = {
   __typename?: 'RadioGroupField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_RelationField_Fragment = {
   __typename?: 'RelationField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   referenceId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   linkedSourceFieldId?: string | null
   valueType: Types.RelationFieldValueType
   parentFieldOptions?: {
      __typename?: 'ParentFieldOptions'
      options: Array<string>
      parentFieldId: string
   } | null
   relation: {
      __typename?: 'RelationOverviewDetails'
      cardinality: Types.Cardinality
      name: string
      relationId: string
      fromSalesTemplateConfig: {
         __typename?: 'RelatedSalesTemplateOverviewDetails'
         salesTemplateId: string
         displayName: string
         pipelineItemType?: Types.PipelineItemType | null
         salesTemplateName: string
         salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
      }
      toSalesTemplateConfig: {
         __typename?: 'RelatedSalesTemplateOverviewDetails'
         salesTemplateId: string
         salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
         displayName: string
         pipelineItemType?: Types.PipelineItemType | null
         salesTemplateName: string
      }
   }
   secondDegreeRelation?: {
      __typename?: 'RelationOverviewDetails'
      cardinality: Types.Cardinality
      name: string
      relationId: string
      fromSalesTemplateConfig: {
         __typename?: 'RelatedSalesTemplateOverviewDetails'
         salesTemplateId: string
         displayName: string
         pipelineItemType?: Types.PipelineItemType | null
         salesTemplateName: string
         salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
      }
      toSalesTemplateConfig: {
         __typename?: 'RelatedSalesTemplateOverviewDetails'
         salesTemplateId: string
         salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
         displayName: string
         pipelineItemType?: Types.PipelineItemType | null
         salesTemplateName: string
      }
   } | null
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_ShortTextField_Fragment = {
   __typename?: 'ShortTextField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isUnique: boolean
   isIdentificationField: boolean
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
   prefixOptions?: {
      __typename?: 'PrefixOptions'
      isEnabled: boolean
      values: Array<string>
      optionsValueType: Types.OptionsValueType
      conditionalPrefixOptions: Array<{
         __typename?: 'ConditionalFieldOptions'
         parentFieldId: string
         options: Array<{
            __typename?: 'ConditionalOptions'
            options: Array<string>
            parentFieldOption: string
         }>
      }>
   } | null
   suffixOptions?: {
      __typename?: 'SuffixOptions'
      isEnabled: boolean
      values: Array<string>
   } | null
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_TimeField_Fragment = {
   __typename?: 'TimeField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   isDependent: boolean
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   timeFieldDefaultValue?: string | null
   relativeDefaultValueConfig?: {
      __typename?: 'TimeRelativeDefaultValueConfig'
      operator: Types.ArithmeticOperation
      noOfSeconds: number
      TimeValueEnum: Types.TimeValueEnum
   } | null
}

export type Sales_Crm_Web_Common_ConfigurationField_Fragment_UrlField_Fragment = {
   __typename?: 'URLField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   alternateDisplayText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   isUnique: boolean
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Common_ConfigurationField_FragmentFragment =
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_CheckboxGroupField_Fragment
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_DateField_Fragment
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_DateTimeField_Fragment
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_DropdownField_Fragment
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_EmailField_Fragment
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_FieldsSelectorField_Fragment
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_FileUploaderField_Fragment
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_FloatField_Fragment
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_GeoLocationField_Fragment
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_GeoShapeField_Fragment
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_IntegerField_Fragment
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_LongTextField_Fragment
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_MultiSelectField_Fragment
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_PhoneNumberField_Fragment
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_PlainTextField_Fragment
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_RadioGroupField_Fragment
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_RelationField_Fragment
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_ShortTextField_Fragment
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_TimeField_Fragment
   | Sales_Crm_Web_Common_ConfigurationField_Fragment_UrlField_Fragment

export type Sales_Crm_Web_Common_Gof_FragmentFragment = {
   __typename?: 'GoF'
   gofId: string
   name: string
   description?: string | null
   orderedFieldIds: Array<string>
   category: Types.GoFCategory
   enableAddAnother: boolean
   addAnotherGofResponsesLimit?: number | null
   fields: Array<
      | {
           __typename?: 'CheckboxGroupField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           options: Array<string>
           isDependent: boolean
           systemFieldEnum?: Types.SystemFieldEnum | null
           salesTemplateId: string
           referenceId?: string | null
           linkedSourceFieldId?: string | null
           iconId?: string | null
           tags: Array<Types.FieldTag>
           multiStringDefaultValue: Array<string>
        }
      | {
           __typename?: 'DateField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           systemFieldEnum?: Types.SystemFieldEnum | null
           salesTemplateId: string
           isDependent: boolean
           referenceId?: string | null
           linkedSourceFieldId?: string | null
           iconId?: string | null
           tags: Array<Types.FieldTag>
           dateFieldDefaultValue?: string | null
           relativeDefaultValueConfig?: {
              __typename?: 'DateRelativeDefaultValueConfig'
              operator: Types.ArithmeticOperation
              noOfDays: number
              DateValueEnum: Types.DateValueEnum
           } | null
        }
      | {
           __typename?: 'DateTimeField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           isDependent: boolean
           systemFieldEnum?: Types.SystemFieldEnum | null
           salesTemplateId: string
           referenceId?: string | null
           linkedSourceFieldId?: string | null
           iconId?: string | null
           tags: Array<Types.FieldTag>
           dateTimeDefaultValue?: string | null
           relativeDefaultValueConfig?: {
              __typename?: 'DateTimeRelativeDefaultValueConfig'
              dateConfig?: {
                 __typename?: 'DateRelativeDefaultValueConfig'
                 operator: Types.ArithmeticOperation
                 noOfDays: number
                 DateValueEnum: Types.DateValueEnum
              } | null
              timeConfig?: {
                 __typename?: 'TimeRelativeDefaultValueConfig'
                 operator: Types.ArithmeticOperation
                 noOfSeconds: number
                 TimeValueEnum: Types.TimeValueEnum
              } | null
           } | null
        }
      | {
           __typename?: 'DropdownField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           options: Array<string>
           isDependent: boolean
           systemFieldEnum?: Types.SystemFieldEnum | null
           salesTemplateId: string
           referenceId?: string | null
           linkedSourceFieldId?: string | null
           isLabelsEnabled: boolean
           optionsValueType: Types.OptionsValueType
           iconId?: string | null
           tags: Array<Types.FieldTag>
           dropdownFieldUiStyle: Types.DropdownFieldUiStyleEnum
           allowOtherOptions: boolean
           stringDefaultValue?: string | null
           optionColors: Array<{
              __typename?: 'OptionColorConfig'
              option: string
              color: Types.ColorEnum
           }>
           conditionalOptions: Array<{
              __typename?: 'ConditionalFieldOptions'
              parentFieldId: string
           }>
        }
      | {
           __typename?: 'EmailField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           regexErrorMessage?: string | null
           validationRegex?: string | null
           isUnique: boolean
           isDependent: boolean
           systemFieldEnum?: Types.SystemFieldEnum | null
           salesTemplateId: string
           referenceId?: string | null
           linkedSourceFieldId?: string | null
           iconId?: string | null
           tags: Array<Types.FieldTag>
           stringDefaultValue?: string | null
        }
      | {
           __typename?: 'FieldsSelectorField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           isDependent: boolean
           options: Array<string>
           systemFieldEnum?: Types.SystemFieldEnum | null
           salesTemplateId: string
           referenceId?: string | null
           linkedSourceFieldId?: string | null
           iconId?: string | null
           tags: Array<Types.FieldTag>
           fieldsSelectorFieldUiStyle: Types.FieldSelectorFieldUiStyleEnum
           fieldSelectorFieldDefaultValue?: string | null
           dependentFields: Array<{
              __typename?: 'DependentFields'
              option: string
              dependentFieldIds: Array<string>
           }>
        }
      | {
           __typename?: 'FileUploaderField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           allowedFormats: Array<string>
           isDependent: boolean
           systemFieldEnum?: Types.SystemFieldEnum | null
           salesTemplateId: string
           referenceId?: string | null
           linkedSourceFieldId?: string | null
           maxNumberOfFilesToUpload: number
           eachFileMaxSizeInKb: number
           canDownload: boolean
           allowPublicAccess: boolean
           iconId?: string | null
           tags: Array<Types.FieldTag>
           stringDefaultValue?: string | null
        }
      | {
           __typename?: 'FloatField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           isUnique: boolean
           isDependent: boolean
           systemFieldEnum?: Types.SystemFieldEnum | null
           salesTemplateId: string
           referenceId?: string | null
           linkedSourceFieldId?: string | null
           isFormulaEnabled: boolean
           iconId?: string | null
           tags: Array<Types.FieldTag>
           decimalPrecisionLimit?: number | null
           floatDefaultValue?: number | null
           rangeConfig?: {
              __typename?: 'FloatRangeConfig'
              floatMinValue?: number | null
              floatMaxValue?: number | null
           } | null
        }
      | {
           __typename?: 'GeoLocationField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           isDependent: boolean
           systemFieldEnum?: Types.SystemFieldEnum | null
           salesTemplateId: string
           referenceId?: string | null
           linkedSourceFieldId?: string | null
           addressFieldIds: Array<string>
           iconId?: string | null
           tags: Array<Types.FieldTag>
        }
      | {
           __typename?: 'GeoShapeField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           isDependent: boolean
           systemFieldEnum?: Types.SystemFieldEnum | null
           salesTemplateId: string
           referenceId?: string | null
           linkedSourceFieldId?: string | null
           variantType: Types.GeoShapeVariantType
           addressFieldIds: Array<string>
           iconId?: string | null
           tags: Array<Types.FieldTag>
        }
      | {
           __typename?: 'IntegerField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           isUnique: boolean
           isDependent: boolean
           systemFieldEnum?: Types.SystemFieldEnum | null
           salesTemplateId: string
           referenceId?: string | null
           linkedSourceFieldId?: string | null
           isFormulaEnabled: boolean
           iconId?: string | null
           tags: Array<Types.FieldTag>
           intDefaultValue?: number | null
           rangeConfig?: {
              __typename?: 'IntegerRangeConfig'
              intMinValue?: number | null
              intMaxValue?: number | null
           } | null
        }
      | {
           __typename?: 'LongTextField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           isDependent: boolean
           systemFieldEnum?: Types.SystemFieldEnum | null
           salesTemplateId: string
           referenceId?: string | null
           linkedSourceFieldId?: string | null
           isFormulaEnabled: boolean
           iconId?: string | null
           tags: Array<Types.FieldTag>
           regexErrorMessage?: string | null
           validationRegex?: string | null
           stringDefaultValue?: string | null
        }
      | {
           __typename?: 'MultiSelectField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           options: Array<string>
           isDependent: boolean
           systemFieldEnum?: Types.SystemFieldEnum | null
           salesTemplateId: string
           referenceId?: string | null
           linkedSourceFieldId?: string | null
           isLabelsEnabled: boolean
           optionsValueType: Types.OptionsValueType
           iconId?: string | null
           tags: Array<Types.FieldTag>
           multiSelectFieldUiStyle: Types.MultiSelectFieldUiStyleEnum
           allowOtherOptions: boolean
           multiStringDefaultValue: Array<string>
           optionColors: Array<{
              __typename?: 'OptionColorConfig'
              option: string
              color: Types.ColorEnum
           }>
           conditionalOptions: Array<{
              __typename?: 'ConditionalFieldOptions'
              parentFieldId: string
           }>
        }
      | {
           __typename?: 'PhoneNumberField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           isUnique: boolean
           isDependent: boolean
           systemFieldEnum?: Types.SystemFieldEnum | null
           salesTemplateId: string
           referenceId?: string | null
           linkedSourceFieldId?: string | null
           isIdentificationField: boolean
           iconId?: string | null
           tags: Array<Types.FieldTag>
           enableOtpVerification?: boolean | null
        }
      | {
           __typename?: 'PlainTextField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           regexErrorMessage?: string | null
           validationRegex?: string | null
           isUnique: boolean
           isDependent: boolean
           systemFieldEnum?: Types.SystemFieldEnum | null
           salesTemplateId: string
           referenceId?: string | null
           linkedSourceFieldId?: string | null
           isIdentificationField: boolean
           isFormulaEnabled: boolean
           autoGenerateApplicationIdInCreation: boolean
           iconId?: string | null
           tags: Array<Types.FieldTag>
           stringDefaultValue?: string | null
        }
      | {
           __typename?: 'RadioGroupField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           options: Array<string>
           isDependent: boolean
           systemFieldEnum?: Types.SystemFieldEnum | null
           salesTemplateId: string
           referenceId?: string | null
           linkedSourceFieldId?: string | null
           iconId?: string | null
           tags: Array<Types.FieldTag>
           stringDefaultValue?: string | null
        }
      | {
           __typename?: 'RelationField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           salesTemplateId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           isDependent: boolean
           systemFieldEnum?: Types.SystemFieldEnum | null
           referenceId?: string | null
           iconId?: string | null
           tags: Array<Types.FieldTag>
           linkedSourceFieldId?: string | null
           valueType: Types.RelationFieldValueType
           parentFieldOptions?: {
              __typename?: 'ParentFieldOptions'
              options: Array<string>
              parentFieldId: string
           } | null
           relation: {
              __typename?: 'RelationOverviewDetails'
              cardinality: Types.Cardinality
              name: string
              relationId: string
              fromSalesTemplateConfig: {
                 __typename?: 'RelatedSalesTemplateOverviewDetails'
                 salesTemplateId: string
                 displayName: string
                 pipelineItemType?: Types.PipelineItemType | null
                 salesTemplateName: string
                 salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
              }
              toSalesTemplateConfig: {
                 __typename?: 'RelatedSalesTemplateOverviewDetails'
                 salesTemplateId: string
                 salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
                 displayName: string
                 pipelineItemType?: Types.PipelineItemType | null
                 salesTemplateName: string
              }
           }
           secondDegreeRelation?: {
              __typename?: 'RelationOverviewDetails'
              cardinality: Types.Cardinality
              name: string
              relationId: string
              fromSalesTemplateConfig: {
                 __typename?: 'RelatedSalesTemplateOverviewDetails'
                 salesTemplateId: string
                 displayName: string
                 pipelineItemType?: Types.PipelineItemType | null
                 salesTemplateName: string
                 salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
              }
              toSalesTemplateConfig: {
                 __typename?: 'RelatedSalesTemplateOverviewDetails'
                 salesTemplateId: string
                 salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
                 displayName: string
                 pipelineItemType?: Types.PipelineItemType | null
                 salesTemplateName: string
              }
           } | null
        }
      | {
           __typename?: 'ShortTextField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           regexErrorMessage?: string | null
           validationRegex?: string | null
           isDependent: boolean
           systemFieldEnum?: Types.SystemFieldEnum | null
           salesTemplateId: string
           referenceId?: string | null
           linkedSourceFieldId?: string | null
           isUnique: boolean
           isIdentificationField: boolean
           isFormulaEnabled: boolean
           iconId?: string | null
           tags: Array<Types.FieldTag>
           stringDefaultValue?: string | null
           prefixOptions?: {
              __typename?: 'PrefixOptions'
              isEnabled: boolean
              values: Array<string>
              optionsValueType: Types.OptionsValueType
              conditionalPrefixOptions: Array<{
                 __typename?: 'ConditionalFieldOptions'
                 parentFieldId: string
                 options: Array<{
                    __typename?: 'ConditionalOptions'
                    options: Array<string>
                    parentFieldOption: string
                 }>
              }>
           } | null
           suffixOptions?: {
              __typename?: 'SuffixOptions'
              isEnabled: boolean
              values: Array<string>
           } | null
        }
      | {
           __typename?: 'TimeField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           systemFieldEnum?: Types.SystemFieldEnum | null
           salesTemplateId: string
           isDependent: boolean
           referenceId?: string | null
           linkedSourceFieldId?: string | null
           iconId?: string | null
           tags: Array<Types.FieldTag>
           timeFieldDefaultValue?: string | null
           relativeDefaultValueConfig?: {
              __typename?: 'TimeRelativeDefaultValueConfig'
              operator: Types.ArithmeticOperation
              noOfSeconds: number
              TimeValueEnum: Types.TimeValueEnum
           } | null
        }
      | {
           __typename?: 'URLField'
           fieldId: string
           permissionType: Types.PermissionType
           gofId: string
           name: string
           description?: string | null
           fieldType?: Types.FieldType | null
           isRequired: boolean
           helpText?: string | null
           helpTextType?: Types.HelpTextType | null
           dynamicLabel?: string | null
           tooltip?: string | null
           placeholderText?: string | null
           alternateDisplayText?: string | null
           regexErrorMessage?: string | null
           validationRegex?: string | null
           isUnique: boolean
           isDependent: boolean
           systemFieldEnum?: Types.SystemFieldEnum | null
           salesTemplateId: string
           referenceId?: string | null
           linkedSourceFieldId?: string | null
           iconId?: string | null
           tags: Array<Types.FieldTag>
           stringDefaultValue?: string | null
        }
   >
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_CheckboxGroupField_Fragment = {
   __typename?: 'CheckboxGroupField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   multiStringDefaultValue: Array<string>
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_DateField_Fragment = {
   __typename?: 'DateField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   isDependent: boolean
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   dateFieldDefaultValue?: string | null
   relativeDefaultValueConfig?: {
      __typename?: 'DateRelativeDefaultValueConfig'
      operator: Types.ArithmeticOperation
      noOfDays: number
      DateValueEnum: Types.DateValueEnum
   } | null
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_DateTimeField_Fragment = {
   __typename?: 'DateTimeField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   dateTimeDefaultValue?: string | null
   relativeDefaultValueConfig?: {
      __typename?: 'DateTimeRelativeDefaultValueConfig'
      dateConfig?: {
         __typename?: 'DateRelativeDefaultValueConfig'
         operator: Types.ArithmeticOperation
         noOfDays: number
         DateValueEnum: Types.DateValueEnum
      } | null
      timeConfig?: {
         __typename?: 'TimeRelativeDefaultValueConfig'
         operator: Types.ArithmeticOperation
         noOfSeconds: number
         TimeValueEnum: Types.TimeValueEnum
      } | null
   } | null
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_DropdownField_Fragment = {
   __typename?: 'DropdownField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isLabelsEnabled: boolean
   optionsValueType: Types.OptionsValueType
   iconId?: string | null
   tags: Array<Types.FieldTag>
   dropdownFieldUiStyle: Types.DropdownFieldUiStyleEnum
   allowOtherOptions: boolean
   stringDefaultValue?: string | null
   optionColors: Array<{
      __typename?: 'OptionColorConfig'
      option: string
      color: Types.ColorEnum
   }>
   conditionalOptions: Array<{
      __typename?: 'ConditionalFieldOptions'
      parentFieldId: string
   }>
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_EmailField_Fragment = {
   __typename?: 'EmailField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   isUnique: boolean
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_FieldsSelectorField_Fragment = {
   __typename?: 'FieldsSelectorField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isDependent: boolean
   options: Array<string>
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   fieldsSelectorFieldUiStyle: Types.FieldSelectorFieldUiStyleEnum
   fieldSelectorFieldDefaultValue?: string | null
   dependentFields: Array<{
      __typename?: 'DependentFields'
      option: string
      dependentFieldIds: Array<string>
   }>
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_FileUploaderField_Fragment = {
   __typename?: 'FileUploaderField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   allowedFormats: Array<string>
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   maxNumberOfFilesToUpload: number
   eachFileMaxSizeInKb: number
   canDownload: boolean
   allowPublicAccess: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_FloatField_Fragment = {
   __typename?: 'FloatField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isUnique: boolean
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   decimalPrecisionLimit?: number | null
   floatDefaultValue?: number | null
   rangeConfig?: {
      __typename?: 'FloatRangeConfig'
      floatMinValue?: number | null
      floatMaxValue?: number | null
   } | null
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_GeoLocationField_Fragment = {
   __typename?: 'GeoLocationField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   addressFieldIds: Array<string>
   iconId?: string | null
   tags: Array<Types.FieldTag>
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_GeoShapeField_Fragment = {
   __typename?: 'GeoShapeField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   variantType: Types.GeoShapeVariantType
   addressFieldIds: Array<string>
   iconId?: string | null
   tags: Array<Types.FieldTag>
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_IntegerField_Fragment = {
   __typename?: 'IntegerField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isUnique: boolean
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   intDefaultValue?: number | null
   rangeConfig?: {
      __typename?: 'IntegerRangeConfig'
      intMinValue?: number | null
      intMaxValue?: number | null
   } | null
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_LongTextField_Fragment = {
   __typename?: 'LongTextField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   regexErrorMessage?: string | null
   validationRegex?: string | null
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_MultiSelectField_Fragment = {
   __typename?: 'MultiSelectField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isLabelsEnabled: boolean
   optionsValueType: Types.OptionsValueType
   iconId?: string | null
   tags: Array<Types.FieldTag>
   multiSelectFieldUiStyle: Types.MultiSelectFieldUiStyleEnum
   allowOtherOptions: boolean
   multiStringDefaultValue: Array<string>
   optionColors: Array<{
      __typename?: 'OptionColorConfig'
      option: string
      color: Types.ColorEnum
   }>
   conditionalOptions: Array<{
      __typename?: 'ConditionalFieldOptions'
      parentFieldId: string
   }>
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_PhoneNumberField_Fragment = {
   __typename?: 'PhoneNumberField'
   isIdentificationField: boolean
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isUnique: boolean
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   enableOtpVerification?: boolean | null
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_PlainTextField_Fragment = {
   __typename?: 'PlainTextField'
   isIdentificationField: boolean
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   isUnique: boolean
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isFormulaEnabled: boolean
   autoGenerateApplicationIdInCreation: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_RadioGroupField_Fragment = {
   __typename?: 'RadioGroupField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_RelationField_Fragment = {
   __typename?: 'RelationField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   referenceId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   linkedSourceFieldId?: string | null
   valueType: Types.RelationFieldValueType
   parentFieldOptions?: {
      __typename?: 'ParentFieldOptions'
      options: Array<string>
      parentFieldId: string
   } | null
   relation: {
      __typename?: 'RelationOverviewDetails'
      cardinality: Types.Cardinality
      name: string
      relationId: string
      fromSalesTemplateConfig: {
         __typename?: 'RelatedSalesTemplateOverviewDetails'
         salesTemplateId: string
         displayName: string
         pipelineItemType?: Types.PipelineItemType | null
         salesTemplateName: string
         salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
      }
      toSalesTemplateConfig: {
         __typename?: 'RelatedSalesTemplateOverviewDetails'
         salesTemplateId: string
         salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
         displayName: string
         pipelineItemType?: Types.PipelineItemType | null
         salesTemplateName: string
      }
   }
   secondDegreeRelation?: {
      __typename?: 'RelationOverviewDetails'
      cardinality: Types.Cardinality
      name: string
      relationId: string
      fromSalesTemplateConfig: {
         __typename?: 'RelatedSalesTemplateOverviewDetails'
         salesTemplateId: string
         displayName: string
         pipelineItemType?: Types.PipelineItemType | null
         salesTemplateName: string
         salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
      }
      toSalesTemplateConfig: {
         __typename?: 'RelatedSalesTemplateOverviewDetails'
         salesTemplateId: string
         salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
         displayName: string
         pipelineItemType?: Types.PipelineItemType | null
         salesTemplateName: string
      }
   } | null
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_ShortTextField_Fragment = {
   __typename?: 'ShortTextField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   isUnique: boolean
   isIdentificationField: boolean
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
   prefixOptions?: {
      __typename?: 'PrefixOptions'
      isEnabled: boolean
      values: Array<string>
      optionsValueType: Types.OptionsValueType
      conditionalPrefixOptions: Array<{
         __typename?: 'ConditionalFieldOptions'
         parentFieldId: string
         options: Array<{
            __typename?: 'ConditionalOptions'
            options: Array<string>
            parentFieldOption: string
         }>
      }>
   } | null
   suffixOptions?: {
      __typename?: 'SuffixOptions'
      isEnabled: boolean
      values: Array<string>
   } | null
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_TimeField_Fragment = {
   __typename?: 'TimeField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   isDependent: boolean
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   timeFieldDefaultValue?: string | null
   relativeDefaultValueConfig?: {
      __typename?: 'TimeRelativeDefaultValueConfig'
      operator: Types.ArithmeticOperation
      noOfSeconds: number
      TimeValueEnum: Types.TimeValueEnum
   } | null
}

export type Sales_Crm_Web_Common_Field_With_Identifiers_UrlField_Fragment = {
   __typename?: 'URLField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   helpTextType?: Types.HelpTextType | null
   dynamicLabel?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   alternateDisplayText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   isUnique: boolean
   isDependent: boolean
   systemFieldEnum?: Types.SystemFieldEnum | null
   salesTemplateId: string
   referenceId?: string | null
   linkedSourceFieldId?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Common_Field_With_IdentifiersFragment =
   | Sales_Crm_Web_Common_Field_With_Identifiers_CheckboxGroupField_Fragment
   | Sales_Crm_Web_Common_Field_With_Identifiers_DateField_Fragment
   | Sales_Crm_Web_Common_Field_With_Identifiers_DateTimeField_Fragment
   | Sales_Crm_Web_Common_Field_With_Identifiers_DropdownField_Fragment
   | Sales_Crm_Web_Common_Field_With_Identifiers_EmailField_Fragment
   | Sales_Crm_Web_Common_Field_With_Identifiers_FieldsSelectorField_Fragment
   | Sales_Crm_Web_Common_Field_With_Identifiers_FileUploaderField_Fragment
   | Sales_Crm_Web_Common_Field_With_Identifiers_FloatField_Fragment
   | Sales_Crm_Web_Common_Field_With_Identifiers_GeoLocationField_Fragment
   | Sales_Crm_Web_Common_Field_With_Identifiers_GeoShapeField_Fragment
   | Sales_Crm_Web_Common_Field_With_Identifiers_IntegerField_Fragment
   | Sales_Crm_Web_Common_Field_With_Identifiers_LongTextField_Fragment
   | Sales_Crm_Web_Common_Field_With_Identifiers_MultiSelectField_Fragment
   | Sales_Crm_Web_Common_Field_With_Identifiers_PhoneNumberField_Fragment
   | Sales_Crm_Web_Common_Field_With_Identifiers_PlainTextField_Fragment
   | Sales_Crm_Web_Common_Field_With_Identifiers_RadioGroupField_Fragment
   | Sales_Crm_Web_Common_Field_With_Identifiers_RelationField_Fragment
   | Sales_Crm_Web_Common_Field_With_Identifiers_ShortTextField_Fragment
   | Sales_Crm_Web_Common_Field_With_Identifiers_TimeField_Fragment
   | Sales_Crm_Web_Common_Field_With_Identifiers_UrlField_Fragment

export const Sales_Crm_Web_Common_IntegerFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_IntegerField on IntegerField {
      fieldId
      permissionType
      gofId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      rangeConfig {
         intMinValue: minValue
         intMaxValue: maxValue
      }
      intDefaultValue: defaultValue
      isUnique
      isDependent
      systemFieldEnum
      salesTemplateId
      referenceId
      linkedSourceFieldId
      isFormulaEnabled
      iconId
      tags
   }
`
export const Sales_Crm_Web_Common_FloatFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_FloatField on FloatField {
      fieldId
      permissionType
      gofId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      rangeConfig {
         floatMinValue: minValue
         floatMaxValue: maxValue
      }
      floatDefaultValue: defaultValue
      isUnique
      isDependent
      systemFieldEnum
      salesTemplateId
      referenceId
      linkedSourceFieldId
      isFormulaEnabled
      iconId
      tags
      decimalPrecisionLimit
   }
`
export const Sales_Crm_Web_Common_EmailFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_EmailField on EmailField {
      fieldId
      permissionType
      gofId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      regexErrorMessage
      validationRegex
      isUnique
      stringDefaultValue: defaultValue
      isDependent
      systemFieldEnum
      salesTemplateId
      referenceId
      linkedSourceFieldId
      iconId
      tags
   }
`
export const Sales_Crm_Web_Common_FileUploaderFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_FileUploaderField on FileUploaderField {
      fieldId
      permissionType
      gofId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      allowedFormats
      stringDefaultValue: defaultValue
      isDependent
      systemFieldEnum
      salesTemplateId
      referenceId
      linkedSourceFieldId
      maxNumberOfFilesToUpload
      eachFileMaxSizeInKb
      canDownload
      allowPublicAccess
      iconId
      tags
   }
`
export const Sales_Crm_Web_Common_LongTextFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_LongTextField on LongTextField {
      fieldId
      permissionType
      gofId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      stringDefaultValue: defaultValue
      isDependent
      systemFieldEnum
      salesTemplateId
      referenceId
      linkedSourceFieldId
      isFormulaEnabled
      iconId
      tags
      regexErrorMessage
      validationRegex
   }
`
export const Sales_Crm_Web_Common_PlainTextFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_PlainTextField on PlainTextField {
      fieldId
      permissionType
      gofId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      regexErrorMessage
      validationRegex
      isUnique
      stringDefaultValue: defaultValue
      isDependent
      systemFieldEnum
      salesTemplateId
      referenceId
      linkedSourceFieldId
      isIdentificationField
      isFormulaEnabled
      autoGenerateApplicationIdInCreation
      iconId
      tags
   }
`
export const Sales_Crm_Web_Common_ShortTextFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_ShortTextField on ShortTextField {
      fieldId
      permissionType
      gofId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      regexErrorMessage
      validationRegex
      stringDefaultValue: defaultValue
      isDependent
      systemFieldEnum
      salesTemplateId
      referenceId
      linkedSourceFieldId
      prefixOptions {
         isEnabled
         values
         optionsValueType
         conditionalPrefixOptions {
            parentFieldId
            options {
               options
               parentFieldOption
            }
         }
      }
      suffixOptions {
         isEnabled
         values
      }
      isUnique
      isIdentificationField
      isFormulaEnabled
      iconId
      tags
   }
`
export const Sales_Crm_Web_Common_UrlFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_URLField on URLField {
      fieldId
      permissionType
      gofId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      alternateDisplayText
      regexErrorMessage
      validationRegex
      isUnique
      stringDefaultValue: defaultValue
      isDependent
      systemFieldEnum
      salesTemplateId
      referenceId
      linkedSourceFieldId
      iconId
      tags
   }
`
export const TimeRelativeDefaultValueConfig_FragmentFragmentDoc = gql`
   fragment TimeRelativeDefaultValueConfig_Fragment on TimeRelativeDefaultValueConfig {
      TimeValueEnum: valueEnum
      operator
      noOfSeconds
   }
`
export const Sales_Crm_Web_Common_TimeFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_TimeField on TimeField {
      fieldId
      permissionType
      gofId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      timeFieldDefaultValue: defaultValue
      systemFieldEnum
      relativeDefaultValueConfig {
         ...TimeRelativeDefaultValueConfig_Fragment
      }
      salesTemplateId
      isDependent
      referenceId
      linkedSourceFieldId
      iconId
      tags
   }
   ${TimeRelativeDefaultValueConfig_FragmentFragmentDoc}
`
export const DateRelativeDefaultValueConfig_FragmentFragmentDoc = gql`
   fragment DateRelativeDefaultValueConfig_Fragment on DateRelativeDefaultValueConfig {
      DateValueEnum: valueEnum
      operator
      noOfDays
   }
`
export const Sales_Crm_Web_Common_DateFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_DateField on DateField {
      fieldId
      permissionType
      gofId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      dateFieldDefaultValue: defaultValue
      systemFieldEnum
      relativeDefaultValueConfig {
         ...DateRelativeDefaultValueConfig_Fragment
      }
      salesTemplateId
      isDependent
      referenceId
      linkedSourceFieldId
      iconId
      tags
   }
   ${DateRelativeDefaultValueConfig_FragmentFragmentDoc}
`
export const Sales_Crm_Web_Common_DateTimeFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_DateTimeField on DateTimeField {
      fieldId
      permissionType
      gofId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      relativeDefaultValueConfig {
         dateConfig {
            ...DateRelativeDefaultValueConfig_Fragment
         }
         timeConfig {
            ...TimeRelativeDefaultValueConfig_Fragment
         }
      }
      dateTimeDefaultValue: defaultValue
      isDependent
      systemFieldEnum
      salesTemplateId
      referenceId
      linkedSourceFieldId
      iconId
      tags
   }
   ${DateRelativeDefaultValueConfig_FragmentFragmentDoc}
   ${TimeRelativeDefaultValueConfig_FragmentFragmentDoc}
`
export const Sales_Crm_Web_Common_DropdownFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_DropdownField on DropdownField {
      fieldId
      permissionType
      gofId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      options
      stringDefaultValue: defaultValue
      isDependent
      systemFieldEnum
      salesTemplateId
      referenceId
      linkedSourceFieldId
      isLabelsEnabled
      optionColors {
         option
         color
      }
      optionsValueType
      conditionalOptions {
         parentFieldId
      }
      iconId
      tags
      dropdownFieldUiStyle
      allowOtherOptions
   }
`
export const Sales_Crm_Web_Common_MultiSelectFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_MultiSelectField on MultiSelectField {
      fieldId
      permissionType
      gofId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      options
      multiStringDefaultValue: defaultValues
      isDependent
      systemFieldEnum
      salesTemplateId
      referenceId
      linkedSourceFieldId
      isLabelsEnabled
      optionColors {
         option
         color
      }
      optionsValueType
      conditionalOptions {
         parentFieldId
      }
      iconId
      tags
      multiSelectFieldUiStyle
      allowOtherOptions
   }
`
export const Sales_Crm_Web_Common_CheckboxGroupFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_CheckboxGroupField on CheckboxGroupField {
      fieldId
      permissionType
      gofId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      options
      multiStringDefaultValue: defaultValues
      isDependent
      systemFieldEnum
      salesTemplateId
      referenceId
      linkedSourceFieldId
      iconId
      tags
   }
`
export const Sales_Crm_Web_Common_RadioGroupFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_RadioGroupField on RadioGroupField {
      fieldId
      permissionType
      gofId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      options
      stringDefaultValue: defaultValue
      isDependent
      systemFieldEnum
      salesTemplateId
      referenceId
      linkedSourceFieldId
      iconId
      tags
   }
`
export const Sales_Crm_Web_Common_PhoneNumberFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_PhoneNumberField on PhoneNumberField {
      fieldId
      permissionType
      gofId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      isUnique
      isDependent
      systemFieldEnum
      salesTemplateId
      referenceId
      linkedSourceFieldId
      isIdentificationField
      iconId
      tags
      enableOtpVerification
   }
`
export const Sales_Crm_Web_Common_FieldsSelectorFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_FieldsSelectorField on FieldsSelectorField {
      fieldId
      permissionType
      gofId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      isDependent
      options
      fieldSelectorFieldDefaultValue: defaultValue
      dependentFields {
         option
         dependentFieldIds
      }
      systemFieldEnum
      salesTemplateId
      referenceId
      linkedSourceFieldId
      iconId
      tags
      fieldsSelectorFieldUiStyle
   }
`
export const Sales_Crm_Web_Common_RelationFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_RelationField on RelationField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      isDependent
      systemFieldEnum
      referenceId
      iconId
      tags
      parentFieldOptions {
         options
         parentFieldId
      }
      linkedSourceFieldId
      relation {
         cardinality
         name
         relationId
         fromSalesTemplateConfig {
            salesTemplateId
            displayName
            pipelineItemType
            salesTemplateName
            salesTemplateType
         }
         toSalesTemplateConfig {
            salesTemplateId
            salesTemplateType
            displayName
            pipelineItemType
            salesTemplateName
         }
      }
      secondDegreeRelation {
         cardinality
         name
         relationId
         fromSalesTemplateConfig {
            salesTemplateId
            displayName
            pipelineItemType
            salesTemplateName
            salesTemplateType
         }
         toSalesTemplateConfig {
            salesTemplateId
            salesTemplateType
            displayName
            pipelineItemType
            salesTemplateName
         }
      }
      valueType
   }
`
export const Sales_Crm_Web_Common_GeoLocationFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_GeoLocationField on GeoLocationField {
      fieldId
      permissionType
      gofId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      isDependent
      systemFieldEnum
      salesTemplateId
      referenceId
      linkedSourceFieldId
      addressFieldIds
      iconId
      tags
   }
`
export const Sales_Crm_Web_Common_GeoShapeFieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_GeoShapeField on GeoShapeField {
      fieldId
      permissionType
      gofId
      name
      description
      fieldType
      isRequired
      helpText
      helpTextType
      dynamicLabel
      tooltip
      placeholderText
      isDependent
      systemFieldEnum
      salesTemplateId
      referenceId
      linkedSourceFieldId
      variantType
      addressFieldIds
      iconId
      tags
   }
`
export const Sales_Crm_Web_Common_ConfigurationField_FragmentFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_ConfigurationField_Fragment on Field {
      ... on IntegerField {
         ...Sales_Crm_Web_Common_IntegerField
      }
      ... on FloatField {
         ...Sales_Crm_Web_Common_FloatField
      }
      ... on EmailField {
         ...Sales_Crm_Web_Common_EmailField
      }
      ... on FileUploaderField {
         ...Sales_Crm_Web_Common_FileUploaderField
      }
      ... on LongTextField {
         ...Sales_Crm_Web_Common_LongTextField
      }
      ... on PlainTextField {
         ...Sales_Crm_Web_Common_PlainTextField
      }
      ... on ShortTextField {
         ...Sales_Crm_Web_Common_ShortTextField
      }
      ... on URLField {
         ...Sales_Crm_Web_Common_URLField
      }
      ... on TimeField {
         ...Sales_Crm_Web_Common_TimeField
      }
      ... on DateField {
         ...Sales_Crm_Web_Common_DateField
      }
      ... on DateTimeField {
         ...Sales_Crm_Web_Common_DateTimeField
      }
      ... on DropdownField {
         ...Sales_Crm_Web_Common_DropdownField
      }
      ... on MultiSelectField {
         ...Sales_Crm_Web_Common_MultiSelectField
      }
      ... on CheckboxGroupField {
         ...Sales_Crm_Web_Common_CheckboxGroupField
      }
      ... on RadioGroupField {
         ...Sales_Crm_Web_Common_RadioGroupField
      }
      ... on PhoneNumberField {
         ...Sales_Crm_Web_Common_PhoneNumberField
      }
      ... on FieldsSelectorField {
         ...Sales_Crm_Web_Common_FieldsSelectorField
      }
      ... on RelationField {
         ...Sales_Crm_Web_Common_RelationField
      }
      ... on GeoLocationField {
         ...Sales_Crm_Web_Common_GeoLocationField
      }
      ... on GeoShapeField {
         ...Sales_Crm_Web_Common_GeoShapeField
      }
   }
   ${Sales_Crm_Web_Common_IntegerFieldFragmentDoc}
   ${Sales_Crm_Web_Common_FloatFieldFragmentDoc}
   ${Sales_Crm_Web_Common_EmailFieldFragmentDoc}
   ${Sales_Crm_Web_Common_FileUploaderFieldFragmentDoc}
   ${Sales_Crm_Web_Common_LongTextFieldFragmentDoc}
   ${Sales_Crm_Web_Common_PlainTextFieldFragmentDoc}
   ${Sales_Crm_Web_Common_ShortTextFieldFragmentDoc}
   ${Sales_Crm_Web_Common_UrlFieldFragmentDoc}
   ${Sales_Crm_Web_Common_TimeFieldFragmentDoc}
   ${Sales_Crm_Web_Common_DateFieldFragmentDoc}
   ${Sales_Crm_Web_Common_DateTimeFieldFragmentDoc}
   ${Sales_Crm_Web_Common_DropdownFieldFragmentDoc}
   ${Sales_Crm_Web_Common_MultiSelectFieldFragmentDoc}
   ${Sales_Crm_Web_Common_CheckboxGroupFieldFragmentDoc}
   ${Sales_Crm_Web_Common_RadioGroupFieldFragmentDoc}
   ${Sales_Crm_Web_Common_PhoneNumberFieldFragmentDoc}
   ${Sales_Crm_Web_Common_FieldsSelectorFieldFragmentDoc}
   ${Sales_Crm_Web_Common_RelationFieldFragmentDoc}
   ${Sales_Crm_Web_Common_GeoLocationFieldFragmentDoc}
   ${Sales_Crm_Web_Common_GeoShapeFieldFragmentDoc}
`
export const Sales_Crm_Web_Common_Gof_FragmentFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_Gof_Fragment on GoF {
      gofId
      name
      description
      orderedFieldIds
      category
      enableAddAnother
      addAnotherGofResponsesLimit
      fields {
         ...Sales_Crm_Web_Common_ConfigurationField_Fragment
      }
   }
   ${Sales_Crm_Web_Common_ConfigurationField_FragmentFragmentDoc}
`
export const Sales_Crm_Web_Common_Field_With_IdentifiersFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_Field_With_Identifiers on Field {
      ... on IntegerField {
         ...Sales_Crm_Web_Common_IntegerField
      }
      ... on FloatField {
         ...Sales_Crm_Web_Common_FloatField
      }
      ... on EmailField {
         ...Sales_Crm_Web_Common_EmailField
      }
      ... on FileUploaderField {
         ...Sales_Crm_Web_Common_FileUploaderField
      }
      ... on LongTextField {
         ...Sales_Crm_Web_Common_LongTextField
      }
      ... on PlainTextField {
         isIdentificationField
         ...Sales_Crm_Web_Common_PlainTextField
      }
      ... on ShortTextField {
         ...Sales_Crm_Web_Common_ShortTextField
      }
      ... on URLField {
         ...Sales_Crm_Web_Common_URLField
      }
      ... on TimeField {
         ...Sales_Crm_Web_Common_TimeField
      }
      ... on DateField {
         ...Sales_Crm_Web_Common_DateField
      }
      ... on DateTimeField {
         ...Sales_Crm_Web_Common_DateTimeField
      }
      ... on DropdownField {
         ...Sales_Crm_Web_Common_DropdownField
      }
      ... on MultiSelectField {
         ...Sales_Crm_Web_Common_MultiSelectField
      }
      ... on CheckboxGroupField {
         ...Sales_Crm_Web_Common_CheckboxGroupField
      }
      ... on RadioGroupField {
         ...Sales_Crm_Web_Common_RadioGroupField
      }
      ... on PhoneNumberField {
         isIdentificationField
         ...Sales_Crm_Web_Common_PhoneNumberField
      }
      ... on FieldsSelectorField {
         ...Sales_Crm_Web_Common_FieldsSelectorField
      }
      ... on RelationField {
         ...Sales_Crm_Web_Common_RelationField
      }
      ... on GeoLocationField {
         ...Sales_Crm_Web_Common_GeoLocationField
      }
      ... on GeoShapeField {
         ...Sales_Crm_Web_Common_GeoShapeField
      }
   }
   ${Sales_Crm_Web_Common_IntegerFieldFragmentDoc}
   ${Sales_Crm_Web_Common_FloatFieldFragmentDoc}
   ${Sales_Crm_Web_Common_EmailFieldFragmentDoc}
   ${Sales_Crm_Web_Common_FileUploaderFieldFragmentDoc}
   ${Sales_Crm_Web_Common_LongTextFieldFragmentDoc}
   ${Sales_Crm_Web_Common_PlainTextFieldFragmentDoc}
   ${Sales_Crm_Web_Common_ShortTextFieldFragmentDoc}
   ${Sales_Crm_Web_Common_UrlFieldFragmentDoc}
   ${Sales_Crm_Web_Common_TimeFieldFragmentDoc}
   ${Sales_Crm_Web_Common_DateFieldFragmentDoc}
   ${Sales_Crm_Web_Common_DateTimeFieldFragmentDoc}
   ${Sales_Crm_Web_Common_DropdownFieldFragmentDoc}
   ${Sales_Crm_Web_Common_MultiSelectFieldFragmentDoc}
   ${Sales_Crm_Web_Common_CheckboxGroupFieldFragmentDoc}
   ${Sales_Crm_Web_Common_RadioGroupFieldFragmentDoc}
   ${Sales_Crm_Web_Common_PhoneNumberFieldFragmentDoc}
   ${Sales_Crm_Web_Common_FieldsSelectorFieldFragmentDoc}
   ${Sales_Crm_Web_Common_RelationFieldFragmentDoc}
   ${Sales_Crm_Web_Common_GeoLocationFieldFragmentDoc}
   ${Sales_Crm_Web_Common_GeoShapeFieldFragmentDoc}
`
